
import React, { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';

import QuotationContent, { DataType, optionBtnPrint } from 'src/components/quotations/QuotationContent';
import ButtonMenu from 'src/components/quotations/ButtonMenu';
import DialogForm from 'src/components/quotations/DialogForm';
import DialogFormPayment from 'src/components/quotations//Payment/DialogForm';
// import BtnGradient from 'src/components/common/button/BtnGradient';
// import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import Stack from '@mui/material/Stack';

const DataDialogDefine = {
  id: 0,
  patientid: 1029,
  open: false
};

const dateDialogPaymentDefine = {
  paymentid: 0,
  patientid: 0,
  caseid: 0,
  quoteid: 0,
  open: false
};

type DataDialogType = {
  id: number;
  patientid: number;
  open: boolean;
};

const QuotationDetail = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [screenPrint, setScreenPrint] = useState<number>(0);
  const [dataDialogForm, setDataDialogForm] = useState<DataDialogType>(DataDialogDefine);
  const [dataDialogPayment, setDataDialogPayment] = useState<{
    paymentid: number;
    patientid: number;
    caseid: number;
    open: boolean;
    quoteid: number;
  }>(dateDialogPaymentDefine);

  const [refresh, setRefresh] = useState<number>(0);
  const [patientSelect, setPatientSelect] = useState<number | null>(null);
    const [fullData, setFullData] = useState<boolean>(false);

  const data: DataType = useMemo(() => {
    return {
      id: Number(searchParams.get('id')),
      patientId: Number(searchParams.get('patientid'))
    }
    // eslint-disable-next-line
  }, [searchParams, refresh]);

  const handleClickBtnPrint = (id: number) => {
    setScreenPrint(id);
    setTimeout(() => {
      setScreenPrint(0);
    }, 1000);
  };

  // const handleClickEdit = () => {
  //   setDataDialogForm({
  //     open: true,
  //     id: data.id,
  //     patientid: data.patientId
  //   });
  // };

  const handleCloseDialogForm = (isRefreshList?: boolean) => {
    setDataDialogForm({
      ...DataDialogDefine
    });

    if (isRefreshList) {
      setRefresh(prev => prev + 1);
    }
  };

  // const handleClickPayment = () => {
  //   setDataDialogPayment({
  //     open: true,
  //     caseid: 0,
  //     patientid: data.patientId,
  //     paymentid: 0,
  //     quoteid: data.id
  //   });
  // };

  const handleCloseDialogFormPayment = (isRefreshList?: boolean) => {
    setDataDialogPayment(dateDialogPaymentDefine);

    if (isRefreshList) {
      setRefresh(prev => prev + 1);
    }
  };

  useEffect(() => {
    if (!(data.patientId && data.id)) {
      setError('不正なリクエストです');
    }
  }, [data.patientId, data.id]);

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <Box>
      <QuotationContent
        data={data}
        screenPrint={screenPrint}
        setPatientSelect={setPatientSelect}
        setFullData={setFullData}
      />
      <Box sx={{
        display: 'flex',
        justifyContent: 'right',
        p: '16px'
      }}
      >
        <Stack direction={'row'} spacing={'8px'}>
          { patientSelect && (
            null
            // <BtnOutlineGradient text='入金' handleButtonClick={handleClickPayment} />
          )}
          <ButtonMenu options={optionBtnPrint} onClick={handleClickBtnPrint} text='印刷' disabled={!fullData} />
          {/* <BtnGradient text='変更' handleButtonClick={handleClickEdit} /> */}
        </Stack>
      </Box>

      <DialogForm
        open={dataDialogForm.open}
        patientId={dataDialogForm.patientid}
        quoteId={dataDialogForm.id}
        onClose={handleCloseDialogForm}
      />

      <DialogFormPayment
        open={dataDialogPayment.open}
        infoPayment={dataDialogPayment}
        onClose={handleCloseDialogFormPayment}
      />
    </Box>
  );
};

export default QuotationDetail;
